import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Mount with createRoot (NOT hydrateRoot) on purpose. The build prerenders a
// full post-JS DOM snapshot into #root (scripts/prerender.mjs) so crawlers and
// no-JS clients get real body HTML. createRoot discards that snapshot and
// re-renders cleanly on the client — zero hydration-mismatch warnings when the
// snapshot drifts from the first client render. Same pattern as SourceTrust.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
